import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, mergeProps as _mergeProps, vShow as _vShow, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "contentHeader flex" }
const _hoisted_2 = { class: "contentBox" }
const _hoisted_3 = { class: "block w-full" }
const _hoisted_4 = { class: "flex mb-4" }
const _hoisted_5 = ["title"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "icon-neu" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["disabled", "title"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "icon-loeschen" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "ml-auto" }
const _hoisted_12 = { class: "text-center" }

import { onBeforeUnmount, onMounted, reactive, ref } from "vue";
import { BryntumGrid } from "@bryntum/grid-vue-3";
import {Menu, Store, StringHelper} from "@bryntum/grid";
import GridInputFilter from "@/components/GridInputFilter";
import { useGlobalStore } from "@/stores/GlobalStore";
import {ErrorLocationType, PopupType, TableType} from '@/utilities/enums/Enums';
import { $t } from "@/utilities/i18n/config";
import {PermissionService} from "@/utilities/services/PermissionService";
import dialog from "@/dialog";
import ErrorHandler from "@/utilities/helpers/ErrorHandler";
import { GeneralResponse } from "@/models/api/Responses";
import Error from "@/components/Error";
import { RegionInfo } from "@/models/group1/RegionInfo";
import {useI18n} from "vue-i18n";
import {checkboxColumnConfig, defaultSpaceAroundTableOnPage} from "@/AppConfig";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import {Group1Service} from "@/utilities/services/entities/Group1Service";



export default /*#__PURE__*/_defineComponent({
  __name: 'Group1',
  setup(__props) {

const gridStore = new Store();
const globalStore = useGlobalStore();
const { t } = useI18n();
const group1Service = new Group1Service();
const permissionService = new PermissionService();

let selectedRegions = ref([]);

const deleteSelection = async() => {
  //drop call without selection
  if(!selectedRegions.value?.some(()=>true)) return;

  const answer = await dialog
      .okText(t('global.delete'))
      .cancelText(t('global.cancel'))
      .confirm(t('regions.confirmDeletionMulti', {count:selectedRegions.value.length}));

  if (answer) {
    let someEntriesFailed = false;
    for (const region of selectedRegions.value){
      const resp = await group1Service.deleteRegion(region.id);

      if(resp === null || resp === undefined || resp?.statusCode !== 0){
        ErrorHandler.handleError(resp, ErrorLocationType.table);
        someEntriesFailed = true;
        continue;
      }

      gridStore.applyChangeset({removed:[{id:region.id}]});
    }

    if (someEntriesFailed) return;

    globalStore.showSuccess(t("global.deleted"));
  }
};

const currentWindowHeight = ref("");
const recalcGridHeight = () => {
  currentWindowHeight.value = `${window.innerHeight-defaultSpaceAroundTableOnPage}px`;
};

const grid = ref(null);
const useGridConfig = {
  headerMenuFeature: false,
  relayStoreEvents: true,
  enableTextSelection: true,
  selectionMode : {
    row	  : true,
    checkbox: checkboxColumnConfig,
    showCheckAll : true,
    deselectFilteredOutRecords: true
  },
  columns : {
    data: [
    { id:'id', field: 'id', text: t('regions.grid.id'), width: 36, },
    { id:'name', field: 'name', text: t('regions.grid.name'), flex: 1, },
    {
      id:'syncId',
      field: 'syncId',
      text: t('regions.grid.syncId'),
      flex: 1,
      type: "template",
      template: ({ record }) => {
				return StringHelper.xss`${record.data.syncId ?? ""}`;
      },
    },
    {
      id:'locations',
      field: 'locations',
      text: '',
			sortable: false,
      width   : 36,
      type: "template",
      template: ({ record }) => {
				if(record.data.locations.length > 0)
					return `<div class='gridRowButton'><span class='icon-pin_outline'></span></div>`;
				return
			},
    },
    {
      id:'menu',
      text	: '',
      width   : 36,
      type	: 'widget',
      align: "center",
      hideable: false,
      resizable: false,
      sortable: false,
      filterable: false,
      widgets : [{
        type	 : 'button',
        width: 36,
        icon	 : 'icon-kontext_horizontal',
        onAction : ({ source: btn }) => {
          const menu = menuFactory(btn.cellInfo.record.data);
          menu.alignTo({ target: btn })
          menu.show();
        }
      }]
    },
  ],
    listeners:{
      async add(event:any){
        if(event.records.length === 1 && event.isMove[event.records[0].id]){
          await globalStore.saveUserColumnOrder(TableType[TableType.group1], event.records[0].id, event.index.toString());
        }
      },
    }
  },
  store: gridStore,
  listeners: {
    selectionChange(event) {
      if(event.selection.length > 0 && event.selection[0]?.data === undefined) return;
      selectedRegions.value = selectedRegions.value.concat(event.selected.map(rr => rr.data))
      selectedRegions.value = selectedRegions.value.filter(r => !event.deselected.map(rr => rr.data).some(rr => r?.id === rr?.id));
    },
    datachange(){
      globalStore.currentItems = gridStore.count;
      globalStore.allItems = gridStore.originalCount;
    },
    cellClick({column, record}) {
      if (column.data.field === 'locations' && record.data.locations.length > 0) {
        globalStore.openPopup({
          data: record.data,
          action: globalStore.closeModal,
          title: "Standorte",
          type: PopupType.group2Locations
        });
      }
    },
  },
  height: currentWindowHeight,
}
const gridConfig = reactive(useGridConfig);

const menuFactory = (record:object) => {
  const menu = new Menu({
    anchor   : true,
    autoShow : true,
    items	: [
      {
        text: t('global.edit'),
        cls: 'color',
        icon: 'icon-editieren',
				hidden: !permissionService.userHasPermission("Region.Edit"),
        weight: 100,
        onItem : ({ menu }) => {
          globalStore.openPopup({
            data:menu.record,
            action:addOrUpdateRegion,
            resetButton:false,
            title:$t("popups.regionEditor.title.edit"),
            type:PopupType.regionEditor
          });
        }
      },
      {
        text   : t('global.delete'),
				hidden: !permissionService.userHasPermission("Region.Delete"),
        cls	: 'color',
        icon: 'icon-loeschen',
        weight : 140,
        onItem: async ({ menu }) => {
          const answer = await dialog
              .okText(t('global.delete'))
              .cancelText(t('global.cancel'))
              .confirm(t('regions.confirmDeletionSingle', {name:menu.record.name}));

          if (answer) {
            const resp = await group1Service.deleteRegion(menu.record.id);

            if (resp === null || resp === undefined || resp?.statusCode !== 0) {
              ErrorHandler.handleError(resp, ErrorLocationType.table);
              return;
            }

            gridStore.applyChangeset({removed: [{id: menu.record.id}]});

            globalStore.showSuccess($t('regions.deleted'));
          }
        }
      }
    ],
  });

  menu.setRecord(record);

  return menu;
};

const newRegion = () => {
  const region = new RegionInfo();

  globalStore.openPopup({
    data: region,
    action: addOrUpdateRegion,
    resetButton: false,
    title: $t("popups.regionEditor.title.new"),
    type: PopupType.regionEditor
  });
}

const addOrUpdateRegion = async () => {
  const region = globalStore.modal.contentObject;

  // dont send empty string as syncId (gets set automatically since input is bound to this prop)
  if (region.syncId === "") region.syncId = undefined;

  const regionResp = await group1Service.addOrUpdateRegion(region);
  if (regionResp === null || regionResp === undefined || regionResp.statusCode !== 0){
    ErrorHandler.handleError(regionResp as GeneralResponse, ErrorLocationType.popup);
    return;
  }

  if(region.id < 0) region.id = regionResp.id;
  // fix selection when it was an update -> replace old value in selected-array
  else if(selectedRegions.value.some(el => el.id === region.id)) {
    selectedRegions.value = selectedRegions.value.filter(el => el.id !== region.id);
    selectedRegions.value.push(region);
  }

  gridStore.add(region);
  gridStore.sort(gridStore.sorters);

  globalStore.closeModal();
  globalStore.showSuccess('Gespeichert');
}

const setGridData = async ()=>{
  // start spinner
  globalStore.gridDataIsLoading = true;

  const regionsResp = await group1Service.getRegions("display");

  if (regionsResp === null || regionsResp === undefined || regionsResp.statusCode !== 0) {
    ErrorHandler.handleError(regionsResp, ErrorLocationType.table);
    return;
  }

  gridStore.setStoreData(regionsResp.regionInfo);

  globalStore.reorderColumns(TableType[TableType.group1]);

  globalStore.closeModal();
  // stop spinner
  globalStore.gridDataIsLoading = false;
};

onMounted(async () => {
  // calculate grid height and sub to window resize event
  recalcGridHeight();
  window.addEventListener('resize', recalcGridHeight);

  globalStore.setGridStore(ref(gridStore));
  globalStore.setGridColumnStore(ref(grid.value?.instance.value?.columns));

  await setGridData();
})

onBeforeUnmount(()=>{
  window.removeEventListener('resize', recalcGridHeight);

  globalStore.setGridStore(null);
  globalStore.setGridColumnStore(null);

  globalStore.currentItems = 0;
  globalStore.allItems = 0;
});

return (_ctx: any,_cache: any) => {
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", null, _toDisplayString(_unref($t)("regions.title")), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(_unref(Error), {
          errorLoc: _unref(ErrorLocationType).table
        }, null, 8, ["errorLoc"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _withDirectives((_openBlock(), _createElementBlock("button", {
              class: "primary mr-2",
              onClick: newRegion,
              title: _unref(t)('regions.new')
            }, _hoisted_7, 8, _hoisted_5)), [
              [_directive_permission, 'Region.Create']
            ]),
            _withDirectives((_openBlock(), _createElementBlock("button", {
              class: "primary mr-2",
              disabled: !_unref(selectedRegions).some(()=>true),
              onClick: deleteSelection,
              title: _unref(t)('global.delete')
            }, _hoisted_10, 8, _hoisted_8)), [
              [_directive_permission, 'Region.Delete']
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_unref(GridInputFilter), {
                gridStore: _unref(gridStore),
                hideFilterButton: true
              }, null, 8, ["gridStore"])
            ])
          ]),
          _createVNode(_unref(BryntumGrid), _mergeProps({
            ref_key: "grid",
            ref: grid
          }, gridConfig, { readOnly: true }), null, 16)
        ])
      ], 512), [
        [_vShow, !_unref(globalStore).gridDataIsLoading]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_12, [
        _createVNode(LoadingSpinner)
      ], 512), [
        [_vShow, _unref(globalStore).gridDataIsLoading]
      ])
    ])
  ], 64))
}
}

})